/**
 * Non-numeric sentinel id. Retained so Tournaments.js can keep guarding
 * leaderboard polling / detail fetches against non-real race ids.
 * Real races always have numeric ids, so this never matches live data.
 */
export const WEEKLY_RACE_MOCK_ID = "weekly-race-preview";

export function isWeeklyRaceMockId(raceId) {
  return raceId === WEEKLY_RACE_MOCK_ID;
}

/**
 * Normalizes the raw race API state into the shape WeeklyRaceContent expects.
 *
 * IMPORTANT: this NEVER fabricates data. Real logged-in players must only ever
 * see their own real standings — no sample competitors, no fake leaderboard,
 * no "preview" race, no invented "not qualified" rank. Empty API results flow
 * through as genuine empty states (handled by WeeklyRaceContent), not mocks.
 */
export function mergeWeeklyRaceWithMocks(apiState) {
  return {
    primaryRace: apiState.primaryRace || null,
    leaderboard: apiState.leaderboard || [],
    qualifyingGames: apiState.qualifyingGames || [],
    otherRaces: apiState.otherRaces || [],
    pastRaces: apiState.pastRaces || [],
    isPreviewDemo: false,
    demoNotQualified: null,
  };
}
